import { FC } from 'react';

const RefreshCWIcon: FC = () => {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 1.99995V7.99995M23 7.99995H17M23 7.99995L18.36 3.63995C17.2853 2.56467 15.9556 1.77916 14.4952 1.35673C13.0348 0.934295 11.4911 0.888705 10.0083 1.22421C8.52547 1.55972 7.1518 2.26539 6.01547 3.27537C4.87913 4.28536 4.01717 5.56674 3.51 6.99995M1 18V12M1 12H7M1 12L5.64 16.36C6.71475 17.4352 8.04437 18.2207 9.50481 18.6432C10.9652 19.0656 12.5089 19.1112 13.9917 18.7757C15.4745 18.4402 16.8482 17.7345 17.9845 16.7245C19.1209 15.7145 19.9828 14.4332 20.49 13"
        stroke="inherit"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RefreshCWIcon;
